<template>
    <div class="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto transition ease-in-out outline-none backdrop bg-overlay focus:outline-none">
        <div class="p-6 mb-8 bg-white rounded shadow-md lg:ml-8">
            <div class="flex items-start justify-between mb-6">
                <div class="p-2 rounded-full bg-muted">
                    <svg class="w-8 h-8 text-red" width="32" height="32" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"></path>
                    </svg>
                </div>
                <button class="border border-transparent focus:border-blue trans-all-linear" type="button" @click="$emit('toggleDeleteModal', showModal)">
                    <svg class="w-8 h-8 text-grey hover:text-grey-dark" width="32" height="32" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                    </svg>
                </button>
            </div>
            <div class="mb-3 leading-normal">
                <h1 class="mb-2 text-base font-bold">Permanently delete {{ type }}.</h1>
                <p class="mb-6 text-sm font-semibold text-grey-darker">{{ msg }}</p>
                <p class="mb-6 text-sm font-semibold text-red">This action cannot be undone.</p>
            </div>
            <footer class="flex justify-end align-center">
                <button @click="$emit('toggleDeleteModal', showModal)" class="p-3 mr-3 text-sm font-semibold border-2 border-grey-light focus:bg-grey-light focus:border-blue trans-all-linear" type="button">Cancel</button>
                <button @click="$emit('deleteItem')" class="p-3 text-sm font-semibold text-white bg-red" tabindex="0" type="button">Delete {{ type }}</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: String,
        msg: String,
    },
    data()
    {
        return {
            showModal: false
        }
    }
}
</script>
